/* AWA split system installation estimator (CLAUDE DRAFT). No cart writes; it only works out an estimate.
   Every selection is passed to the quote form (awa-product-quote.js) so it arrives in the enquiry email. */
(() => {
  if (customElements.get('awa-install-estimator')) return;
  const money = (c) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((Number(c) || 0) / 100);
  const STORE = 'awa_postcode_v1';
  const ICONS = {
    pending: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-5.6-7-11a7 7 0 0 1 14 0c0 5.4-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    available: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 10 17 19 7"/></svg>',
    unavailable: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M7 7l10 10M17 7 7 17"/></svg>'
  };

  class AWAInstallEstimator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-awie-data]').textContent); } catch (_) { this.cfg = {}; }
      this.pipe = this.querySelector('[data-awie-pipe]');
      this.cover = this.querySelector('[data-awie-cover]');
      this.pcInput = this.querySelector('[data-awie-postcode]');
      this.pcBox = this.querySelector('[data-awie-pc-result]');
      this.pcError = this.querySelector('[data-awie-pc-error]');
      this.coverage = 'neutral'; this.pc = '';
      this.pipe.min = this.cfg.pipeIncluded || 3; if (Number(this.pipe.value) < Number(this.pipe.min)) this.pipe.value = this.pipe.min;
      this.addEventListener('change', () => this.render());
      this.addEventListener('input', (e) => { if (e.target === this.pcInput) { this.pcInput.value = this.pcInput.value.replace(/\D/g, '').slice(0, 4); } else this.render(); });
      this.querySelectorAll('[data-awie-step]').forEach((b) => b.addEventListener('click', () => {
        const inp = b.dataset.awieStep === 'pipe' ? this.pipe : this.cover;
        const v = Math.min(Number(inp.max), Math.max(Number(inp.min), (Number(inp.value) || 0) + Number(b.dataset.dir)));
        inp.value = v; this.render();
      }));
      this.querySelector('[data-awie-pc-form]').addEventListener('submit', (e) => { e.preventDefault(); this.check(true); });
      // Refresh the quote details right before the quote form opens (captures the latest selections)
      this.querySelector('[data-awie-quote]')?.addEventListener('click', () => this.render(), true);
      // Prefill from the postcode the customer already saved elsewhere on the site
      let saved = '';
      try { saved = (window.AWAPostcode && window.AWAPostcode.get && window.AWAPostcode.get()?.postcode) || JSON.parse(localStorage.getItem(STORE) || 'null')?.postcode || ''; } catch (_) {}
      if (/^\d{4}$/.test(saved)) { this.pcInput.value = saved; setTimeout(() => this.check(false), 0); }
      this.render();
    }

    size() { return Number(this.querySelector('[data-awie-size]:checked')?.value || 0); }
    tier(kw) { return (this.cfg.tiers || []).find((t) => kw <= t.max) || null; }
    elec(kw) { return (this.cfg.elec || []).find((e) => kw < e.below) || null; }

    check(save) {
      const pc = String(this.pcInput.value || '').trim();
      const engine = window.AWAInstallationCoverage;
      if (!/^\d{4}$/.test(pc) || (engine && !engine.isAustralianPostcode(pc))) {
        this.pcError.textContent = 'Enter a valid 4-digit Australian postcode.'; this.pcError.hidden = false; this.pcBox.hidden = true; this.coverage = 'neutral'; this.pc = ''; return this.render();
      }
      this.pcError.hidden = true; this.pc = pc;
      let ok = null;
      if (this.cfg.rules && engine) { const r = engine.evaluate({ enabled: true, rules: this.cfg.rules, parsed: engine.parseRules(this.cfg.rules) }, pc); ok = r.available; }
      this.coverage = ok === false ? 'unavailable' : 'available';
      this.pcBox.hidden = false;
      this.pcBox.classList.toggle('is-available', ok !== false);
      this.pcBox.classList.toggle('is-unavailable', ok === false);
      this.pcBox.querySelector('[data-awie-pc-icon]').textContent = ok === false ? '\u00d7' : '\u2713';
      this.pcBox.querySelector('[data-awie-pc-status]').textContent = ok === false ? 'INSTALLATION NOT AVAILABLE' : 'INSTALLATION AVAILABLE';
      this.pcBox.querySelector('[data-awie-pc-message]').textContent = ok === false ? pc + ' is outside our standard installation area. Request a quote and we\u2019ll check options for you.' : 'We install in ' + pc + '. Your estimate is below.';
      if (save) {
        try {
          if (window.AWAPostcode && window.AWAPostcode.set) window.AWAPostcode.set(pc, { source: 'awa-install-estimator' });
          else localStorage.setItem(STORE, JSON.stringify({ postcode: pc, savedAt: new Date().toISOString(), expiresAt: new Date(Date.now() + 30 * 864e5).toISOString(), version: 1 }));
        } catch (_) {}
      }
      this.render();
    }

    render() {
      const kw = this.size(), cfg = this.cfg, lines = [];
      const t = this.tier(kw);
      const set = (sel, v) => { const el = this.querySelector(sel); if (el) el.textContent = v; };
      set('[data-awie-install-title]', t ? t.title : 'Installation');
      set('[data-awie-install-price]', t && t.available ? money(t.price) : 'Quote');
      if (t && t.available) lines.push([t.title, t.price]);

      const inc = Number(cfg.pipeIncluded || 3);
      const pipeM = Math.max(inc, Number(this.pipe.value) || inc), extraPipe = pipeM - inc;
      const pipeCost = extraPipe * (cfg.pipeRate || 0);
      set('[data-awie-pipe-price]', extraPipe ? '+' + money(pipeCost) : 'Included');
      if (extraPipe) lines.push(['Extra pipe & electrical (' + extraPipe + ' m \u00d7 ' + money(cfg.pipeRate) + ')', pipeCost]);

      const coverInc = Number(cfg.coverIncluded == null ? 2 : cfg.coverIncluded);
      const coverM = Math.max(0, Number(this.cover.value) || 0), extraCover = Math.max(0, coverM - coverInc), coverCost = extraCover * (cfg.coverRate || 0);
      set('[data-awie-cover-price]', extraCover ? '+' + money(coverCost) : coverM ? 'Included' : 'None');
      if (extraCover) lines.push(['Extra PVC pipe cover (' + extraCover + ' m \u00d7 ' + money(cfg.coverRate) + ')', coverCost]);

      const mk = this.querySelector('[data-awie-mount]:checked')?.value;
      const m = mk && cfg.mounts ? cfg.mounts[mk] : null;
      if (m && m.title) lines.push([m.title, m.price]);

      const e = this.elec(kw);
      const wantElec = this.querySelector('[data-awie-elec]:checked')?.value === 'yes';
      set('[data-awie-elec-title]', e ? e.title : '');
      set('[data-awie-elec-price]', e ? '+' + money(e.price) : '');
      if (wantElec && e) lines.push([e.title, e.price]);

      const wantRem = this.querySelector('[data-awie-rem]:checked')?.value === 'yes';
      if (wantRem && cfg.removal) lines.push([cfg.removal.title, cfg.removal.price]);

      const total = lines.reduce((s, l) => s + Number(l[1] || 0), 0);
      const ul = this.querySelector('[data-awie-lines]'); ul.textContent = '';
      lines.forEach((l) => { const li = document.createElement('li'); const a = document.createElement('span'); a.textContent = l[0]; const b = document.createElement('span'); b.className = 'awa-installation2__price'; b.textContent = money(l[1]); li.append(a, b); ul.appendChild(li); });
      const quoteOnly = !(t && t.available);
      set('[data-awie-total]', quoteOnly ? 'Quote' : money(total));
      set('[data-awie-total2]', quoteOnly ? 'Quote' : money(total));

      // Postcode status box in the summary
      const cov = this.querySelector('[data-awie-coverage]');
      const state = this.coverage === 'unavailable' ? 'unavailable' : this.coverage === 'available' ? 'available' : 'pending';
      cov.dataset.state = state;
      cov.querySelector('[data-awie-cov-icon]').innerHTML = ICONS[state];
      set('[data-awie-cov-title]', state === 'available' ? 'Installation available in ' + this.pc : state === 'unavailable' ? 'Outside our installation area' : 'Check your postcode');
      set('[data-awie-cov-msg]', state === 'available' ? 'Our licensed installers cover your area.' : state === 'unavailable' ? this.pc + ' isn\u2019t in our standard area. Request a quote and we\u2019ll check options.' : 'Enter your installation postcode to confirm we install in your area.');

      const shop = this.querySelector('[data-awie-shop]');
      shop.textContent = 'Shop ' + kw.toFixed(1) + ' kW split systems';
      shop.href = '/search?q=' + encodeURIComponent(kw.toFixed(1) + 'kW split') + '&type=product&options%5Bprefix%5D=last';

      // Everything the customer chose, handed to the quote form as separate fields
      const q = this.querySelector('[data-awie-quote]');
      if (!q) return;
      const d = q.dataset;
      d.productTitle = 'Split system installation estimate (' + kw.toFixed(1) + ' kW)';
      d.productPrice = quoteOnly ? 'Installation by quote' : 'Estimate ' + money(total) + ' incl. GST';
      d.installationPostcode = this.pc;
      d.estimateSize = kw.toFixed(1) + ' kW split system';
      d.estimateInstall = t ? t.title + (t.available ? ' \u2013 ' + money(t.price) : ' \u2013 by quote') : 'By quote';
      d.estimatePipe = pipeM + ' m total (' + inc + ' m included' + (extraPipe ? ', ' + extraPipe + ' m extra = ' + money(pipeCost) : ', no extra') + ')';
      d.estimateCover = coverM + ' m total (' + coverInc + ' m included' + (extraCover ? ', ' + extraCover + ' m extra = ' + money(coverCost) : ', no extra') + ')';
      d.estimateMount = m && m.title ? m.title + ' \u2013 ' + money(m.price) : 'No mount';
      d.estimateElectrical = wantElec && e ? e.title + ' \u2013 ' + money(e.price) : 'Not required';
      d.estimateRemoval = wantRem && cfg.removal ? cfg.removal.title + ' \u2013 ' + money(cfg.removal.price) : 'No';
      d.estimateCoverage = this.pc ? this.pc + (state === 'unavailable' ? ' \u2013 outside standard installation area' : ' \u2013 in installation area') : 'Postcode not checked';
      d.estimateLines = lines.map((l) => l[0] + ': ' + money(l[1])).join(' | ');
      d.estimateTotal = quoteOnly ? 'By quote' : money(total);
    }
  }
  customElements.define('awa-install-estimator', AWAInstallEstimator);
})();
